<template>
  <div>
    <rkm-table
        :fields="fields"
        :items="laudos"
        class="mt-2"
        tag="div"
        hide-pagination
        hide-filters
    >
        <template v-slot:cell(actions)="{ index }">
            <rkm-button
                @click="download(laudos[index])"
                color="primary"
                small
                title="Visualizar"
            >
                <rkm-icon icon="download" />
            </rkm-button>
        </template>
    </rkm-table>
  </div>
</template>

<script>
//Mixins
import { error, repository } from '@/mixins'

//Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {

            return [
                { key: 'name', label: 'Laudos' },
                { key: 'actions', label: 'Ações', class: 'col-min' }
            ]
        }
    },
    created() {

        this.repositories = {
            laudos: this.getConectaSusRepository('prontoAtendimento.laudoExame')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        download(laudo) {

            this.setLoading()

            this.repositories.laudos.download(laudo.id, { hash: laudo.hash }).then(response => {
                const file = new Blob([response.data], { type: "application/pdf" }),
                    url = window.URL.createObjectURL(file)

                window.open(url)
            })
            .finally(() => this.unsetLoading())
        },
    },
    mixins: [error,repository],
    props: {
        laudos: { type: Array, required: true },
    }
}
</script>